document.addEventListener('DOMContentLoaded', function(){

  const bigSwiper = new Swiper('#gallery .big', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0
  });

  const thumbSwiper = new Swiper('#gallery .thumb', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    controller: {
      control: bigSwiper,
    },
    navigation: {
      nextEl: '.swiperBtn[data-target=prev]',
      prevEl: '.swiperBtn[data-target=next]',
    }
  });
})

